export default __webpack_public_path__ + "static/media/wTop_2.967c6cdd.bin";